<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="reservationId" id="reservationId" type="number" pInputText>
            <label for="reservationId">Res #</label>
            @for (validation of validationMessages.reservationId; track validation) {
              <span>
                @if (form1.get('reservationId').hasError(validation.type) && (form1.get('reservationId').dirty || form1.get('reservationId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="statusId" id="statusId" type="number" pInputText>
            <label for="statusId">StatusId</label>
            @for (validation of validationMessages.statusId; track validation) {
              <span>
                @if (form1.get('statusId').hasError(validation.type) && (form1.get('statusId').dirty || form1.get('statusId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="propertyId" id="propertyId" type="number" pInputText>
            <label for="propertyId">PropertyId</label>
            @for (validation of validationMessages.propertyId; track validation) {
              <span>
                @if (form1.get('propertyId').hasError(validation.type) && (form1.get('propertyId').dirty || form1.get('propertyId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="xmlApartmentId" id="xmlApartmentId" type="text" pInputText>
            <label for="xmlApartmentId">Xml ApartmentId</label>
            @for (validation of validationMessages.xmlApartmentId; track validation) {
              <span>
                @if (form1.get('xmlApartmentId').hasError(validation.type) && (form1.get('xmlApartmentId').dirty || form1.get('xmlApartmentId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="dateFrom" inputId="dateFrom" appendTo="body">
            </p-calendar>
            <label for="dateFrom">From Date</label>
            @for (validation of validationMessages.dateFrom; track validation) {
              <span>
                @if (form1.get('dateFrom').hasError(validation.type) && (form1.get('dateFrom').dirty || form1.get('dateFrom').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="dateTo" inputId="dateTo" appendTo="body">
            </p-calendar>
            <label for="dateTo">To Date</label>
            @for (validation of validationMessages.dateTo; track validation) {
              <span>
                @if (form1.get('dateTo').hasError(validation.type) && (form1.get('dateTo').dirty || form1.get('dateTo').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="arrivalTime" inputId="arrivalTime" appendTo="body">
            </p-calendar>
            <label for="arrivalTime">Arrival Time</label>
            @for (validation of validationMessages.arrivalTime; track validation) {
              <span>
                @if (form1.get('arrivalTime').hasError(validation.type) && (form1.get('arrivalTime').dirty || form1.get('arrivalTime').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="numberOfGuests" id="numberOfGuests" type="number" pInputText>
            <label for="numberOfGuests">Number Of Guests</label>
            @for (validation of validationMessages.numberOfGuests; track validation) {
              <span>
                @if (form1.get('numberOfGuests').hasError(validation.type) && (form1.get('numberOfGuests').dirty || form1.get('numberOfGuests').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputNumber formControlName="ruPrice" [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="ruPrice">RUPrice</label>
            @for (validation of validationMessages.ruPrice; track validation) {
              <span>
                @if (form1.get('ruPrice').hasError(validation.type) && (form1.get('ruPrice').dirty || form1.get('ruPrice').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputNumber formControlName="clientPrice" [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="clientPrice">Client Price</label>
            @for (validation of validationMessages.clientPrice; track validation) {
              <span>
                @if (form1.get('clientPrice').hasError(validation.type) && (form1.get('clientPrice').dirty || form1.get('clientPrice').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputNumber formControlName="alreadyPaid" [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="alreadyPaid">Already Paid</label>
            @for (validation of validationMessages.alreadyPaid; track validation) {
              <span>
                @if (form1.get('alreadyPaid').hasError(validation.type) && (form1.get('alreadyPaid').dirty || form1.get('alreadyPaid').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="resApaId" id="resApaId" type="number" pInputText>
            <label for="resApaId">Res ApaId</label>
            @for (validation of validationMessages.resApaId; track validation) {
              <span>
                @if (form1.get('resApaId').hasError(validation.type) && (form1.get('resApaId').dirty || form1.get('resApaId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="stayId" id="stayId" type="number" pInputText>
            <label for="stayId">StayId</label>
            @for (validation of validationMessages.stayId; track validation) {
              <span>
                @if (form1.get('stayId').hasError(validation.type) && (form1.get('stayId').dirty || form1.get('stayId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="hotelId" id="hotelId" type="number" pInputText>
            <label for="hotelId">HotelId</label>
            @for (validation of validationMessages.hotelId; track validation) {
              <span>
                @if (form1.get('hotelId').hasError(validation.type) && (form1.get('hotelId').dirty || form1.get('hotelId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="roomId" id="roomId" type="number" pInputText>
            <label for="roomId">RoomId</label>
            @for (validation of validationMessages.roomId; track validation) {
              <span>
                @if (form1.get('roomId').hasError(validation.type) && (form1.get('roomId').dirty || form1.get('roomId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="rateId" id="rateId" type="number" pInputText>
            <label for="rateId">RateId</label>
            @for (validation of validationMessages.rateId; track validation) {
              <span>
                @if (form1.get('rateId').hasError(validation.type) && (form1.get('rateId').dirty || form1.get('rateId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="policyText" id="policyText" [rows]="2" pInputTextarea></textarea>
            <label for="policyText">Policy Text</label>
            @for (validation of validationMessages.policyText; track validation) {
              <span>
                @if (form1.get('policyText').hasError(validation.type) && (form1.get('policyText').dirty || form1.get('policyText').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="surName" id="surName" type="text" pInputText>
            <label for="surName">SurName</label>
            @for (validation of validationMessages.surName; track validation) {
              <span>
                @if (form1.get('surName').hasError(validation.type) && (form1.get('surName').dirty || form1.get('surName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>



        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="email" id="email" type="text" pInputText>
            <label for="email">Email</label>
            @for (validation of validationMessages.email; track validation) {
              <span>
                @if (form1.get('email').hasError(validation.type) && (form1.get('email').dirty || form1.get('email').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="phone" id="phone" type="text" pInputText>
            <label for="phone">Phone</label>
            @for (validation of validationMessages.phone; track validation) {
              <span>
                @if (form1.get('phone').hasError(validation.type) && (form1.get('phone').dirty || form1.get('phone').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="skypeId" id="skypeId" type="text" pInputText>
            <label for="skypeId">SkypeId</label>
            @for (validation of validationMessages.skypeId; track validation) {
              <span>
                @if (form1.get('skypeId').hasError(validation.type) && (form1.get('skypeId').dirty || form1.get('skypeId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="address" id="address" type="text" pInputText>
            <label for="address">Name</label>
            @for (validation of validationMessages.address; track validation) {
              <span>
                @if (form1.get('address').hasError(validation.type) && (form1.get('address').dirty || form1.get('address').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="zipCode" id="zipCode" type="text" pInputText>
            <label for="zipCode">Zip Code</label>
            @for (validation of validationMessages.zipCode; track validation) {
              <span>
                @if (form1.get('zipCode').hasError(validation.type) && (form1.get('zipCode').dirty || form1.get('zipCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="countryId" id="countryId" type="number" pInputText>
            <label for="countryId">CountryId</label>
            @for (validation of validationMessages.countryId; track validation) {
              <span>
                @if (form1.get('countryId').hasError(validation.type) && (form1.get('countryId').dirty || form1.get('countryId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="languageId" id="languageId" type="number" pInputText>
            <label for="languageId">LanguageId</label>
            @for (validation of validationMessages.languageId; track validation) {
              <span>
                @if (form1.get('languageId').hasError(validation.type) && (form1.get('languageId').dirty || form1.get('languageId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="numberOfAdults" id="numberOfAdults" type="number" pInputText>
            <label for="numberOfAdults">Number Of Adults</label>
            @for (validation of validationMessages.numberOfAdults; track validation) {
              <span>
                @if (form1.get('numberOfAdults').hasError(validation.type) && (form1.get('numberOfAdults').dirty || form1.get('numberOfAdults').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="numberOfChildren" id="numberOfChildren" type="number" pInputText>
            <label for="numberOfChildren">Number Of Children</label>
            @for (validation of validationMessages.numberOfChildren; track validation) {
              <span>
                @if (form1.get('numberOfChildren').hasError(validation.type) && (form1.get('numberOfChildren').dirty || form1.get('numberOfChildren').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="numberOfInfants" id="numberOfInfants" type="number" pInputText>
            <label for="numberOfInfants">Number Of Infants</label>
            @for (validation of validationMessages.numberOfInfants; track validation) {
              <span>
                @if (form1.get('numberOfInfants').hasError(validation.type) && (form1.get('numberOfInfants').dirty || form1.get('numberOfInfants').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="age" id="age" type="number" pInputText>
            <label for="age">Age</label>
            @for (validation of validationMessages.age; track validation) {
              <span>
                @if (form1.get('age').hasError(validation.type) && (form1.get('age').dirty || form1.get('age').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="creator" id="creator" type="text" pInputText>
            <label for="creator">Creator</label>
            @for (validation of validationMessages.creator; track validation) {
              <span>
                @if (form1.get('creator').hasError(validation.type) && (form1.get('creator').dirty || form1.get('creator').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="cancelTypeId" id="cancelTypeId" type="number" pInputText>
            <label for="cancelTypeId">Cancel TypeId</label>
            @for (validation of validationMessages.cancelTypeId; track validation) {
              <span>
                @if (form1.get('cancelTypeId').hasError(validation.type) && (form1.get('cancelTypeId').dirty || form1.get('cancelTypeId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <h6 for="archived">Archived Options</h6>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['archived']" inputId="archived" [binary]="true"></p-checkbox>
            <span class="archived-nm">Is Archived?</span>
          </div>
          @for (validation of validationMessages.archived; track validation) {
            <span>
              @if (form1.get('archived').hasError(validation.type) && (form1.get('archived').dirty || form1.get('archived').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (ruReservationId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!ruReservationId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (ruReservationId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>